/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BillingFrequency } from './BillingFrequency';
import {
    BillingFrequencyFromJSON,
    BillingFrequencyFromJSONTyped,
    BillingFrequencyToJSON,
    BillingFrequencyToJSONTyped,
} from './BillingFrequency';
import type { CalculationType } from './CalculationType';
import {
    CalculationTypeFromJSON,
    CalculationTypeFromJSONTyped,
    CalculationTypeToJSON,
    CalculationTypeToJSONTyped,
} from './CalculationType';
import type { ApiUserTasksGetLastSelectedIdParameter } from './ApiUserTasksGetLastSelectedIdParameter';
import {
    ApiUserTasksGetLastSelectedIdParameterFromJSON,
    ApiUserTasksGetLastSelectedIdParameterFromJSONTyped,
    ApiUserTasksGetLastSelectedIdParameterToJSON,
    ApiUserTasksGetLastSelectedIdParameterToJSONTyped,
} from './ApiUserTasksGetLastSelectedIdParameter';
import type { CalculationCycleStatus } from './CalculationCycleStatus';
import {
    CalculationCycleStatusFromJSON,
    CalculationCycleStatusFromJSONTyped,
    CalculationCycleStatusToJSON,
    CalculationCycleStatusToJSONTyped,
} from './CalculationCycleStatus';
import type { CalculationCycleDetailResponse } from './CalculationCycleDetailResponse';
import {
    CalculationCycleDetailResponseFromJSON,
    CalculationCycleDetailResponseFromJSONTyped,
    CalculationCycleDetailResponseToJSON,
    CalculationCycleDetailResponseToJSONTyped,
} from './CalculationCycleDetailResponse';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface GetCalculationCycleResponse
 */
export interface GetCalculationCycleResponse {
    /**
     * 
     * @type {ApiUserTasksGetLastSelectedIdParameter}
     * @memberof GetCalculationCycleResponse
     */
    id: ApiUserTasksGetLastSelectedIdParameter;
    /**
     * 
     * @type {Date}
     * @memberof GetCalculationCycleResponse
     */
    cycleDate: Date;
    /**
     * 
     * @type {CalculationType}
     * @memberof GetCalculationCycleResponse
     */
    type: CalculationType;
    /**
     * 
     * @type {Date}
     * @memberof GetCalculationCycleResponse
     */
    startDate: Date;
    /**
     * 
     * @type {Date}
     * @memberof GetCalculationCycleResponse
     */
    endDate: Date;
    /**
     * 
     * @type {BillingFrequency}
     * @memberof GetCalculationCycleResponse
     */
    frequency: BillingFrequency;
    /**
     * 
     * @type {CalculationCycleStatus}
     * @memberof GetCalculationCycleResponse
     */
    status: CalculationCycleStatus;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof GetCalculationCycleResponse
     */
    processedCount: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof GetCalculationCycleResponse
     */
    failedCount: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {string}
     * @memberof GetCalculationCycleResponse
     */
    description: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetCalculationCycleResponse
     */
    isClosed: boolean | null;
    /**
     * 
     * @type {Array<CalculationCycleDetailResponse>}
     * @memberof GetCalculationCycleResponse
     */
    details: Array<CalculationCycleDetailResponse>;
}



/**
 * Check if a given object implements the GetCalculationCycleResponse interface.
 */
export function instanceOfGetCalculationCycleResponse(value: object): value is GetCalculationCycleResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('cycleDate' in value) || value['cycleDate'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('startDate' in value) || value['startDate'] === undefined) return false;
    if (!('endDate' in value) || value['endDate'] === undefined) return false;
    if (!('frequency' in value) || value['frequency'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('processedCount' in value) || value['processedCount'] === undefined) return false;
    if (!('failedCount' in value) || value['failedCount'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('isClosed' in value) || value['isClosed'] === undefined) return false;
    if (!('details' in value) || value['details'] === undefined) return false;
    return true;
}

export function GetCalculationCycleResponseFromJSON(json: any): GetCalculationCycleResponse {
    return GetCalculationCycleResponseFromJSONTyped(json, false);
}

export function GetCalculationCycleResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCalculationCycleResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': ApiUserTasksGetLastSelectedIdParameterFromJSON(json['id']),
        'cycleDate': (new Date(json['cycleDate'])),
        'type': CalculationTypeFromJSON(json['type']),
        'startDate': (new Date(json['startDate'])),
        'endDate': (new Date(json['endDate'])),
        'frequency': BillingFrequencyFromJSON(json['frequency']),
        'status': CalculationCycleStatusFromJSON(json['status']),
        'processedCount': ApiUserTasksGetPageParameterFromJSON(json['processedCount']),
        'failedCount': ApiUserTasksGetPageParameterFromJSON(json['failedCount']),
        'description': json['description'],
        'isClosed': json['isClosed'],
        'details': ((json['details'] as Array<any>).map(CalculationCycleDetailResponseFromJSON)),
    };
}

export function GetCalculationCycleResponseToJSON(json: any): GetCalculationCycleResponse {
    return GetCalculationCycleResponseToJSONTyped(json, false);
}

export function GetCalculationCycleResponseToJSONTyped(value?: GetCalculationCycleResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': ApiUserTasksGetLastSelectedIdParameterToJSON(value['id']),
        'cycleDate': value['cycleDate'].toISOString().substring(0,10),
        'type': CalculationTypeToJSON(value['type']),
        'startDate': value['startDate'].toISOString().substring(0,10),
        'endDate': value['endDate'].toISOString().substring(0,10),
        'frequency': BillingFrequencyToJSON(value['frequency']),
        'status': CalculationCycleStatusToJSON(value['status']),
        'processedCount': ApiUserTasksGetPageParameterToJSON(value['processedCount']),
        'failedCount': ApiUserTasksGetPageParameterToJSON(value['failedCount']),
        'description': value['description'],
        'isClosed': value['isClosed'],
        'details': ((value['details'] as Array<any>).map(CalculationCycleDetailResponseToJSON)),
    };
}

